var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.992,
    height: 32.993,
    viewBox: "0 0 32.992 32.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#0222ba;}.a{opacity:0.302;}.b{opacity:0.401;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10352.345 -4042)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.1.8a16.5,16.5,0,1,1,0,32.993Z",
    transform: "translate(10336.741 4041.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.9,33.793A16.5,16.5,0,1,1,32.9.8Z",
    transform: "translate(10335.945 4041.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/Token.e64247ab1508a84ab52cc99f73746dfb.svg";
export { ForwardRef as ReactComponent };